import * as _ from "lodash";

export class Organisation {
    public readonly requestIgnoreList = ["localStorageService"];

    public localInfo: any = null;
    public canvassingType: any = null;
    public oid: any = null;
    public oleader?: number;
    // AV-17974: Xero link columns from the admin list query
    public xero_status?: string | null;
    public xero_contact_id?: string | null;
    public xero_name?: string | null;
    public xero_outstanding?: string | null;
    public xero_overdue?: string | null;
    public xero_currency?: string | null;
    public xero_contact_status?: string | null;
    public ufname?: string;
    public ulname?: string;
    public uemail?: string;
    /** One campaign in the organisation, for the admin join & open control */
    public first_campaignid?: number;

    public oname?: any;
    public limits?: any;
    public campaigntimestamp?: any;
    public member?: any;
    public ostatus?: string;
    public campaigns?: any;
    public permissionid: string;
    public stats?: any;
    public divisions?: any;
    public checked?: any;
    public features?: any;
    public divisionids?: any;
    public langcode?: string;

    public localStorageService: any;

    constructor(localStorageService: any, data?: object) {
        this.localStorageService = localStorageService;

        if (data) {
            this.setData(data);
        }
        this.canvassingType = null;
    }

    setData(data: object): void {
        _.merge(this, data);
    }

    getLocalStorage(): any {
        if (this.localStorageService.isSupported && this.oid) {
            const orgInfo = this.localStorageService.get("org" + this.oid);
            if (!!orgInfo && orgInfo !== "null") this.localInfo = orgInfo;
            else this.localInfo = {};
        }
        return this.localInfo;
    }

    saveLocalStorage(): void {
        if (this.localStorageService.isSupported) {
            this.localStorageService.set("org" + this.oid, this.localInfo);
        }
    }
}
